var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAuthenticated)?_c('Portal',[_c('Pricing',{attrs:{"is-authenticated":_vm.isAuthenticated}})],1):_c('PortalAuth',[_c('Pricing',{attrs:{"is-authenticated":_vm.isAuthenticated}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }